import { z } from "zod";

export const DistrictResponseSchema = z.object({
  name: z.string(),
  driver: z.number(),
});

export type DistrictPayload = z.infer<typeof DistrictResponseSchema>;
